import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import Modal from "components/Modal/Modal"
import ConfirmModal from "components/ConfirmModal/ConfirmModal"
import toastMessages from "stores/toastMessages"
import Input from "components/Input/Input"
import { INPUT_MAX_LENGTH_LARGE } from "config/constants"

interface IShippingInstructionsModalProps {
    shippingInstructions?: string
    onSave?: (shippingInstructions: string) => Promise<void>
    onClose: () => void
}

const ShippingInstructionsModal: FC<IShippingInstructionsModalProps> = ({
    shippingInstructions: initShippingInstructions,
    onSave,
    onClose,
}) => {
    const { t } = useTranslation()
    const isEdit = !!initShippingInstructions
    const [shippingInstructions, setShippingInstructions] = useState(initShippingInstructions || "")
    const [isSaving, setIsSaving] = useState(false)

    async function handleSave() {
        if (!onSave) return

        setIsSaving(true)
        try {
            await onSave(shippingInstructions)
            onClose()
        } catch (e) {
            toastMessages.showSystemError()
            setIsSaving(false)
        }
    }

    if (onSave) {
        return (
            <ConfirmModal
                title={t(isEdit ? "prepareShipping.editShippingInstructions" : "prepareShipping.addShippingInstructions")}
                maxWidth="586px"
                onClose={onClose}
                confirmButtonLabel={t("common.save")}
                onConfirm={handleSave}
                isBusy={isSaving}>
                <Input
                    type="textarea"
                    value={shippingInstructions}
                    onChange={e => setShippingInstructions(e.target.value)}
                    disabled={isSaving}
                    rows={8}
                    maxLength={INPUT_MAX_LENGTH_LARGE}
                />
            </ConfirmModal>
        )
    }

    return (
        <Modal
            title={t("shippingOrders.shippingInstructions")}
            maxWidth="586px"
            onClose={onClose}>
            <div className="white-space-pre-wrap">
                {shippingInstructions}
            </div>
        </Modal>
    )

}

export default ShippingInstructionsModal
